import api from './ApiManager';
import arraybufferService from 'app/services/arraybufferService';
import urlConfig from 'app/config/urlConfig';
import { AUTH, COMMON, DOCUMENT } from './constants/endPoint';
import { LEADS } from 'app/utils/constants/endPoint';

const header = {
  'Content-Type': 'application/json',
  'Accept': '*/*',
};

const BEARER = 'Bearer '

const requestApi = async (endpoint, query = {}) => {
  let headers = {
    ...header,
  };

  let config = {
    endpoint: endpoint,
    headers: headers,
  };

  if (query.data) {
    config.data = query.data;
  }
  if (query.params) {
    config.params = query.params;
  }
  if (query.subfolder) {
    config.subfolder = query.subfolder;
  }

  let apiDef = urlConfig[endpoint];

  if (apiDef.needToken) {
    if (!apiDef.generateToken) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = BEARER + token;
      }
      if (endpoint.includes('DOWNLOAD') && endpoint !== COMMON.TNC_DOWNLOAD && endpoint !== DOCUMENT.DOCUMENT_DOWNLOAD) {
        /* excel download */
        config['responseType'] = 'arraybuffer'
        return await arraybufferService.request(config);
      }

    } else {
      const resToken = await requestApi(AUTH.GENERATE_TOKEN, {
        subfolder: '/' + (localStorage.getItem('USER_WV') ?? 'm_connect')
      })
      const { token } = resToken.data.data;
      localStorage.setItem("token", token)
      config.headers.Authorization = BEARER + token;
    }
  }

  const response = await api.request(config);

  return response;
};

export {
  requestApi
};
